import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from "moment";
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { GetApp } from '@material-ui/icons';
import { CSVLink } from "react-csv";
import * as C from 'components';
import { buildCheckInHistoryCsvUrl } from "config/pictreeCheckInExportConfig";

const useStyles = makeStyles({
  loaderBox: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loaderBarImg: {
    width: 40,
  },
  tableContainer: {
    display: 'flex',
    minHeight: 200,
  },
  dateTableWrapper: {
    float: 'left',
  },
  dataTableWrapper: {
    float: 'left',
    overflow: 'scroll',
  },
  leftTable: {
    border: '1px solid #eee',
  },
  lblGameName: {
    color: '#000',
    fontSize: 13,
    minWidth: 160,
  },
  lblUniqueUser: {
    color: '#6f6969',
    fontSize: 11,
    minWidth: 180,
  },
  _GAIv: {
    height: 40,
    backgroundColor: "#4#4#4",
    borderLeft: "1px solid #eee6e6",
    color: "#666",
    fontSize: 11,
    minWidth: 80,
    paddingRight: 10,
    textAlign: 'right',
  },
  dataHeaderTd: {
    width: 100,
    paddingRight: 10,
    borderBottom: '1px solid #eee6e6',
  },
  dataTableBody: {
    fontSize: 11,
    paddingRight: 10,
    paddingBottom: 0,
    textAlign: 'right',
    verticalAlign: 'middle',
    border: '1px solid #eee6e6',
    height: '3em',
    overflowX: 'auto',
  },
  dataCellTd: {
    fontSize: 13,
    paddingRight: 10,
    paddingBottom: 0,
    paddingLeft: 10,
    textAlign: 'right',
    verticalAlign: 'middle',
    borderBottom: '1px solid #eee6e6',
    borderRight: '1px solid #eee6e6',
    height: 45,
  },
  tTdHeader: {
    paddingLeft: '1rem',
    paddingRight: 19,
    fontWeight: 'bold',
    height: 39,
  },
  tTd: {
    height: 44,
    width: 250,
    paddingLeft: '1rem',
    borderBottom: '1px solid #eee',
    borderCollapse: 'collapse',
  },
  tableNumberData: {
    fontSize: 13,
    paddingBottom: 4,
  },
  exportBtn: {
    marginLeft: 16,
  },
  titleContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  widgetTitle: {
    flexBasis: '50%',
    fontSize: 16,
    padding: 16,
  },
  exportBtnContainer: {
    marginLeft: 'auto',
    padding: 16,
  }
});

const KpiSalesTableByGame = ({
  checkInTrend,
  chartSize,
  pageTopLoader,
  common,
  dateRange,
  overview = false,
  selectedSeason = [],
}) => {
  const classes = useStyles();
  const selectedSeasonId = selectedSeason?.[0]?.seasonId;
  const checkInHistoryCsvUrl = common
    ? buildCheckInHistoryCsvUrl(dateRange?.[1], selectedSeasonId)
    : null;
  const handleCheckInHistoryDownload = () => {
    if (checkInHistoryCsvUrl) {
      window.location.assign(checkInHistoryCsvUrl);
    }
  };
  const getTableLabelColumn = () => {
    return  <>
              <tr>
                <td className={classes.tTd}>
                  <div className={classes.lblGameName}>チェックイン数</div>
                </td>
              </tr>
              {overview && (
                <tr>
                  <td className={classes.tTd}>
                    <div className={classes.lblGameName}>チェックイン対象アセット数</div>
                  </td>
                </tr>
              )}
              <tr>
                <td className={classes.tTd}>
                  <div className={classes.lblGameName}>{overview ? "チェックイン者数" : "ユニークユーザー数"}</div>
                </td>
              </tr>
            </>
  }

  const getDataTable = (checkInTrend) => {
    return  <>
              <tr>
              {checkInTrend[0]["count"].map((d, i) =>
                <td className={classes.dataCellTd} key={i}>{d}</td>
              )}
              </tr >
              {overview && (
                <tr>
                {checkInTrend[0]["asset"].map((d, i) =>
                  <td className={classes.dataCellTd} key={i}>{d}</td>
                )}
                </tr>
              )}
              <tr>
              {checkInTrend[0]["unique"].map((d, i) =>
                <td className={classes.dataCellTd} key={i}>{d}</td>
              )}
              </tr >
            </>
  }

  const getExportData = (checkInTrend) => {
    if (checkInTrend.length === 0) {
      return [["\uFEFFチェックインデータ"]];
    }
    let exportData = [];
    if (checkInTrend.length > 0) {
      let headerArray = ["チェックインデータ"];
      let numOfHeaderData = checkInTrend[0]['date'].length;
      for (let j=0; j<numOfHeaderData; j++) {
        headerArray.push(
          chartSize !== "hour"
          ? (overview
            ? moment.utc(checkInTrend[0]['date'][j]).format('YYYY-MM-DD')
            : moment(checkInTrend[0]['date'][j]).format('M/D'))
            : moment(checkInTrend[0]['date'][j]).format('M/D  HH:mm')
        );
      }
      exportData.push(headerArray);

      let countArray = ["チェックイン回数"];
      for (let j=0; j<numOfHeaderData; j++) {
        countArray.push(checkInTrend[0]['count'][j]);
      }
      exportData.push(countArray);

      let upuArray = [overview ? "チェックイン者数" : "ユニークユーザー数"];
      for (let j=0; j<numOfHeaderData; j++) {
        upuArray.push(checkInTrend[0]['unique'][j]);
      }
      exportData.push(upuArray);
      if (overview) {
        let assetArray = ["チェックイン対象アセット数"];
        for (let j = 0; j < numOfHeaderData; j++) {
          assetArray.push(checkInTrend[0]['asset'][j]);
        }
        exportData.splice(2, 0, assetArray);
      }
    }
    exportData[0][0] = `\uFEFF${exportData[0][0]}`;
    return exportData;
  }

  return (
    <Paper>
      <div className={classes.titleContainer}>
        <div className={classes.widgetTitle}></div>
        <div className={classes.exportBtnContainer}>
          {common && (
            <Button
                component="button"
                onClick={handleCheckInHistoryDownload}
                variant="contained"
                color="default"
                className={classes.exportBtn}
                startIcon={<GetApp />}
                disabled={!checkInHistoryCsvUrl}
            >
              チェックイン履歴（累計）
            </Button>
          )}
          <CSVLink
              data={getExportData(checkInTrend)}
              filename={`PicTree - チェックイントレンドデータ`}
          >
            <Button
                variant="contained"
                color="default"
                className={classes.exportBtn}
                startIcon={<GetApp />}
            >
              CSV出力
            </Button>
          </CSVLink>
        </div>
      </div>
      <div className={classes.tableContainer}>
      {pageTopLoader
        ? <div className={classes.loaderBox}><img className={classes.loaderBarImg} src={`/static/images/loader-bar.gif`} /></div>
        : checkInTrend.length > 0 ?
        checkInTrend.length > 0 ?
              <>
                <div className={classes.dateTableWrapper}>
                  <table className={classes.leftTable}>
                      <tbody>
                      <tr>
                          <td className={classes.tTdHeader}>
                          </td>
                      </tr >
                      {getTableLabelColumn(checkInTrend)}
                      </tbody>
                  </table>
                </div>

                <div className={classes.dataTableWrapper}>
                  <table className={classes.dataTableBody}>
                    <tbody>
                      <tr className={classes._GAIv}>
                      {checkInTrend[0]['date'].map((item, i) => (
                        <td className={classes.dataHeaderTd} key={i}>
                          {chartSize !== "hour"
                            ? moment(item).format('M/D')
                            : moment(item).format('M/D HH:mm')}
                        </td>
                      ))}
                      </tr >
                        {getDataTable(checkInTrend)}
                    </tbody>
                  </table>
                </div>
              </>
              : <div className={classes.loaderBox}><C.NoData text="No Data" /></div>
            : null
        }
      </div>
    </Paper>
  )
}

KpiSalesTableByGame.propTypes = {
    classes: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => ({
  checkInTrend: ownProps.common
    ? state.pictreeCommon.checkInTrend
    : state.pictree.checkInTrend,
  chartSize: state.pictree.chartSize,
  pageTopLoader: state.page.pageTopLoader,
  dateRange: ownProps.dateRange,
});

const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(KpiSalesTableByGame);
